'use strict'
var twentyninetimes = twentyninetimes || {}

twentyninetimes.sidebarColumns =
  twentyninetimes.sidebarColumns ||
  (function () {
    const copyButton = document.querySelector('#copyLink')

    function init() {
      if (!copyButton) return
      copyButton.addEventListener('click', () => {
        navigator.clipboard.writeText(copyButton.getAttribute('data-url')).then(
          function () {
            copyButton.classList.add('copied')
            setTimeout(() => {
              copyButton.classList.remove('copied')
            }, 1000)
            console.log('Link copied to clipboard')
          },
          function (err) {
            console.error('Could not copy text: ', err)
          }
        )
      })
    }

    return {
      init: init,
    }
  })()
